import { useCallback } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { supplierDataGridSx } from '../../supplier_datagrid/supplierDataGridStyles';

export const StrategyListTableContainer = ({
  columns,
  data,
  setSelectedStrategy,
  isStrategyAdmin
}) => {
  const handleRowSelectionChange = useCallback(
    (selectionModel) => {
      // MUI X v8 selection model is { type: 'include' | 'exclude', ids: Set }, not an array
      const { type, ids } = selectionModel;
      const isSelected = (strategyId) =>
        type === 'include' ? ids.has(strategyId) : !ids.has(strategyId);

      setSelectedStrategy(data.filter((row) => isSelected(row.strategyId)));
    },
    [data, setSelectedStrategy]
  );

  return (
    <DataGridPro
      columns={columns}
      rows={data}
      getRowId={(row) => row.strategyId}
      checkboxSelection={isStrategyAdmin}
      disableRowSelectionOnClick
      onRowSelectionModelChange={handleRowSelectionChange}
      initialState={{
        pagination: { paginationModel: { pageSize: 300, page: 0 } }
      }}
      pageSizeOptions={[300]}
      density="compact"
      autoHeight
      sx={supplierDataGridSx}
    />
  );
};
